// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","menu":"Navbar_menu__dbeuV","icon":"Navbar_icon__zclbV","active":"Navbar_active__MLHq1","pulse":"Navbar_pulse__vUkUT"};